import { ItemList } from 'orm'

class CompanyFileFieldMapping extends ItemList {
    getEntityKey() {
        return "contact/company_file_field_mapping"
    }

}
export const companyFileFieldMappingList = new CompanyFileFieldMapping("company_file_field_mapping__default")
